import React, { useState, useEffect } from 'react';
import API from '../../../Services/BaseService';
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import "../../../Component/CommonPopup/commonPopup.css"
import { useDispatch, useSelector } from 'react-redux';
import ls from 'local-storage';
import Loading from "../../../Component/Loading/Loading";
import ErrorPopup from '../../FallBackUI/ErrorPopup';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const ViewSellerNotesPopup = (props) => {

    const history = useHistory();
    const [loading, setloading] = useState(true);

    const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [alertmessage, setAlertMessage] = useState("");
    const [alerttitle, setAlertTitle] = useState("");
    const [alertimg, setAlertImg] = useState("");
    const [comments, setComments] = useState(props.notesName);
    const [commentsError, setCommentsError] = useState("");
    const adminData = useSelector(state => state.LoginReducer.payload);
    const [togglePopupOpen, setTogglePopupOpen] = useState(true);
    const [sellerNotes, setSellerNotes] = useState("");

    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    const toggleCommonPopup = () => {
        setIsCommonPopupOpen(!isCommonPopupOpen);
    }
    useEffect(() => {

        // getSellerNotes();

    }, [])
    const getSellerNotes = () => {

        let request = {

            seller_notes_id: props.notesId,

        }
        console.log("=====request", request)

        API.post("sellernotes_view/condition", request).then(response => {
            console.log("check the seller note  view", response);
            if (response.data.success === true) {
            }
            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }

        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    }
    useEffect(() => {

        getSellerDetails();

    }, [])

    const getSellerDetails = () => {
        let request = {

            bill_of_sale_id: props.bosId,

        }
        API.post("sellernotes_list/condition", request).then(response => {

            if (response.data.success === true) {
                setSellerNotes(response.data?.data)
                setloading(false);

            }
            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }
        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    }

    function formatTime(value) {
        let local = ""
        let offset = ""
        local = new Date(value);
        offset = local.getTimezoneOffset();
        value = new Date(local.getTime() - offset * 60000);
        value = moment(value).format('MMMM D, YYYY hh:mm A')
        return value;
    }


    return (

        <Modal show={true} onHide={props.toggle} centered>
            <Modal.Header  className="Terms-login">
                <Modal.Title>Seller Notes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errorFlag ? (
                    <ErrorPopup error={errors} />
                ) : loading ? (
                    <Loading />
                ) : (
                    <>
                        <div className="table-box sellernotes-sec">
                            <div className="table-responsive fixTableHead">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="border-top-0">Date</th>
                                            <th className="border-top-0">User</th>
                                            <th className="border-top-0">Location</th>
                                            <th className="border-top-0">Notes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sellerNotes?.length > 0 ? sellerNotes?.map((sellerNote, index) =>
                                            <tr key={index}>
                                                <td>{formatTime(sellerNote?.date_tz)}</td>
                                                <td className="text-color">{sellerNote?.dealer_name}</td>
                                                <td>{sellerNote?.location}</td>
                                                <td>{sellerNote?.seller_notes}</td>
                                              
                                            </tr>
                                        ) : <tr><td colSpan="5" className='text-center'><p>No Data Found</p></td></tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="Sellernotes">
                            <Button className="cta-btn" onClick={props.toggle}>Close</Button>
                        </div>

                    </>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default ViewSellerNotesPopup;